module.exports = "<h2>{{message}}</h2>\n<h3><a id=\"signInLink\" routerLink=\"/\">\n  Click here to login to app \n</a> </h3>\n\n\n"